// removed by extract-text-webpack-plugin
module.exports = {"root":"_1R-qK","container":"_36r8C","mobileContainer":"_1eM24","active":"_1Fqq-","fullwidth":"_2ninB","logo":"_1lpmz","navs":"kodgW","desktopNavs":"_1DeG4","hamburger":"_3DnWb","avatar":"_2tYd0","mobileNavs":"_1ixMf","link":"_1bcGs"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Header/styles.css
// module id = 1230
// module chunks = 26